/*
 * The "how many drinks for 50 pax" calculator (S7-05; SEO_SPEC §4 guide 2). A rule of thumb, stated as one:
 * two drinks a guest in the first hour, one for each hour after, a quarter more outdoors, split across cans,
 * water and packet drinks by the mix chosen, rounded up to whole cartons of 24. It quotes NO price and NO
 * delivery day - the build's worst failure is a page that names a number the checkout does not honour, and a
 * guide has no way to know today's price. It says how many cartons and links to where they are.
 *
 * DEGRADING: the snippet renders a static table for six party sizes first, from the same arithmetic (the unit
 * test recomputes every cell with estimate() below), and the form is `hidden` until this script boots and
 * removes the attribute. With JavaScript off the table is the answer and there is no dead form.
 *
 * The pure half is exported for node the way assets/dn-cart.js and dn-quick-order.js do it; the DOM boot is
 * skipped when there is no document.
 */
(function () {
  'use strict';

  var RULES = {
    firstHour: 2,        // drinks a guest in the first hour
    perExtraHour: 1,     // and one for each hour after
    outdoorFactor: 1.25, // a quarter more in the sun
    pack: { can: 24, water: 24, packet: 24 },
    mixes: {
      'mostly-canned': { can: 0.6, water: 0.25, packet: 0.15 },
      'half-water':    { can: 0.4, water: 0.5,  packet: 0.1 },
      'kids':          { can: 0.2, water: 0.3,  packet: 0.5 },
    },
    maxGuests: 2000,
    maxHours: 8,
  };

  /** The rows the snippet prints without JavaScript: guests at 3 hours, indoors, mostly canned. */
  var PRESETS = { guests: [20, 30, 50, 80, 100, 150], hours: 3, setting: 'indoor', mix: 'mostly-canned' };

  function clampInt(v, lo, hi) {
    var n = Math.floor(Number(v));
    if (!isFinite(n)) return lo;
    return Math.min(hi, Math.max(lo, n));
  }

  /**
   * estimate({ guests, hours, setting, mix }) →
   *   { guests, hours, setting, mix, drinks, units: {can, water, packet}, cartons: {can, water, packet} }
   * Shares are rounded and the packet count takes the remainder, so the three always sum to `drinks`.
   */
  function estimate(input) {
    var guests = clampInt(input && input.guests, 0, RULES.maxGuests);
    var hours = clampInt(input && input.hours, 1, RULES.maxHours);
    var setting = input && input.setting === 'outdoor' ? 'outdoor' : 'indoor';
    var mixName = input && RULES.mixes[input.mix] ? input.mix : 'mostly-canned';
    var mix = RULES.mixes[mixName];
    var perGuest = RULES.firstHour + RULES.perExtraHour * (hours - 1);
    var factor = setting === 'outdoor' ? RULES.outdoorFactor : 1;
    var drinks = Math.ceil(guests * perGuest * factor);
    var can = Math.round(drinks * mix.can);
    var water = Math.round(drinks * mix.water);
    var packet = Math.max(0, drinks - can - water);
    var units = { can: can, water: water, packet: packet };
    var cartons = {
      can: Math.ceil(can / RULES.pack.can),
      water: Math.ceil(water / RULES.pack.water),
      packet: Math.ceil(packet / RULES.pack.packet),
    };
    return { guests: guests, hours: hours, setting: setting, mix: mixName, drinks: drinks, units: units, cartons: cartons };
  }

  /** One plain sentence. No price, no date. */
  function sentence(r) {
    if (r.guests === 0) return 'Enter how many guests are coming.';
    var where = r.setting === 'outdoor' ? 'outdoors' : 'indoors';
    var parts = [];
    if (r.cartons.can) parts.push(r.cartons.can + (r.cartons.can === 1 ? ' carton' : ' cartons') + ' of cans');
    if (r.cartons.water) parts.push(r.cartons.water + ' of water');
    if (r.cartons.packet) parts.push(r.cartons.packet + ' of packet drinks');
    var order = parts.length ? 'Order ' + parts.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.' : '';
    return 'For ' + r.guests + ' guests over ' + r.hours + (r.hours === 1 ? ' hour ' : ' hours ') + where + ': about ' + r.drinks + ' drinks. ' + order;
  }

  function boot(root) {
    var form = root.querySelector('[data-dn-calc-form]');
    var out = root.querySelector('[data-dn-calc-out]');
    if (!form || !out) return;
    function read() {
      var f = form.elements;
      return { guests: f.guests && f.guests.value, hours: f.hours && f.hours.value, setting: f.setting && f.setting.value, mix: f.mix && f.mix.value };
    }
    function render() {
      var r = estimate(read());
      out.textContent = sentence(r);
      var cells = root.querySelectorAll('[data-dn-calc-cell]');
      for (var i = 0; i < cells.length; i++) {
        var k = cells[i].getAttribute('data-dn-calc-cell');
        var v = k === 'drinks' ? r.drinks : r.cartons[k];
        cells[i].textContent = v === undefined ? '' : String(v);
      }
    }
    form.addEventListener('input', render);
    form.addEventListener('submit', function (e) { e.preventDefault(); render(); });
    form.removeAttribute('hidden');
    render();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { RULES: RULES, PRESETS: PRESETS, estimate: estimate, sentence: sentence };
  }
  if (typeof document !== 'undefined') {
    var roots = document.querySelectorAll('[data-dn-guide-calc]');
    for (var i = 0; i < roots.length; i++) boot(roots[i]);
  }
})();
